import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="closeevent" id="closeevent"></a>
    <h1 {...{
      "id": "windowcloseevent"
    }}>{`window.CloseEvent`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent`}</a>{`  `}</p>
    <a name="new-closeevent-new" id="new-closeevent-new"></a>
    <h2 {...{
      "id": "closeeventcode-reason-wasclean"
    }}>{`CloseEvent(code, reason, wasClean)`}</h2>
    <p>{`Creates an instance of CloseEvent.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`reason`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`wasClean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="closeevent-code" id="closeevent-code"></a>
    <h2 {...{
      "id": "code--number"
    }}>{`code ⇒ `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`number`}</inlineCode>{` - returns the close code sent by the server.  `}</p>
    <a name="closeevent-reason" id="closeevent-reason"></a>
    <h2 {...{
      "id": "reason--number"
    }}>{`reason ⇒ `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`number`}</inlineCode>{` - returns the string indicating the reason the server closed the connection..  `}</p>
    <a name="closeevent-wasclean" id="closeevent-wasclean"></a>
    <h2 {...{
      "id": "wasclean--boolean"
    }}>{`wasClean ⇒ `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{` - returns a boolean that inndicates whether or not the connection was cleanly closed.  `}</p>
    <a name="event-type" id="event-type"></a>
    <h2 {...{
      "id": "type"
    }}>{`type`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-istrusted" id="event-istrusted"></a>
    <h2 {...{
      "id": "istrusted--boolean"
    }}>{`isTrusted : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-target" id="event-target"></a>
    <h2 {...{
      "id": "target--node"
    }}>{`target : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-currenttarget" id="event-currenttarget"></a>
    <h2 {...{
      "id": "currenttarget--node"
    }}>{`currentTarget : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-bubbles" id="event-bubbles"></a>
    <h2 {...{
      "id": "bubbles--boolean"
    }}>{`bubbles : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-cancelable" id="event-cancelable"></a>
    <h2 {...{
      "id": "cancelable--boolean"
    }}>{`cancelable : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-eventphase" id="event-eventphase"></a>
    <h2 {...{
      "id": "eventphase"
    }}>{`eventPhase`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-defaultprevented" id="event-defaultprevented"></a>
    <h2 {...{
      "id": "defaultprevented--boolean"
    }}>{`defaultPrevented : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-returnvalue" id="event-returnvalue"></a>
    <h2 {...{
      "id": "returnvalue--"
    }}>{`returnValue : `}<inlineCode parentName="h2">{`*`}</inlineCode></h2>
    <a name="event-initevent" id="event-initevent"></a>
    <h2 {...{
      "id": "initeventtypearg-bubblesarg-cancelablearg"
    }}>{`initEvent(typeArg, bubblesArg, cancelableArg)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`typeArg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`bubblesArg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cancelableArg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="event-preventdefault" id="event-preventdefault"></a>
    <h2 {...{
      "id": "preventdefault"
    }}>{`preventDefault()`}</h2>
    <a name="event-stopimmediatepropagation" id="event-stopimmediatepropagation"></a>
    <h2 {...{
      "id": "stopimmediatepropagation"
    }}>{`stopImmediatePropagation()`}</h2>
    <a name="event-stoppropagation" id="event-stoppropagation"></a>
    <h2 {...{
      "id": "stoppropagation"
    }}>{`stopPropagation()`}</h2>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      